import { get } from "lodash";

export const getStoreFromSliceName = (state, sliceName) =>
  get(state, sliceName.split("/"), {});
